import { useEffect, useState } from 'react';

export const RECENT_SEARCH_KEY = 'POSTPOP_RECENT_SEARCHES_V1';
const CHANGE = 'postpop:recent-searches';
const LIMIT = 8;
let memory = [];
let memoryOnly = false;
export const normalizeSearch = (value) =>
  String(value || '')
    .trim()
    .replace(/\s+/g, ' ');
const clean = (values) => {
  const seen = new Set();
  return (Array.isArray(values) ? values : [])
    .filter((value) => typeof value === 'string')
    .map(normalizeSearch)
    .filter((value) => {
      const key = value.toLocaleLowerCase();
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .slice(0, LIMIT);
};
export function readRecentSearches() {
  if (memoryOnly) return memory;
  try {
    const raw = localStorage.getItem(RECENT_SEARCH_KEY) || '[]';
    try {
      memory = clean(JSON.parse(raw));
    } catch {
      memory = [];
    }
  } catch {
    /* Storage restrictions must not prevent searching. */
  }
  return memory;
}
function save(items) {
  memory = clean(items);
  try {
    localStorage.setItem(RECENT_SEARCH_KEY, JSON.stringify(memory));
    memoryOnly = false;
  } catch {
    memoryOnly = true;
  }
  window.dispatchEvent(new Event(CHANGE));
}
export const recentSearches = {
  add(value) {
    const query = normalizeSearch(value);
    if (query) save([query, ...readRecentSearches()]);
  },
  remove(value) {
    save(readRecentSearches().filter((item) => item !== value));
  },
  clear() {
    save([]);
  },
};
export function useRecentSearches() {
  const [items, setItems] = useState(readRecentSearches);
  useEffect(() => {
    const update = () => setItems([...readRecentSearches()]);
    const storage = (event) => {
      if (!event.key || event.key === RECENT_SEARCH_KEY) update();
    };
    window.addEventListener(CHANGE, update);
    window.addEventListener('storage', storage);
    return () => {
      window.removeEventListener(CHANGE, update);
      window.removeEventListener('storage', storage);
    };
  }, []);
  return items;
}
